<div class="pt-[125px] md:pt-[145px] lg:pt-[185px] xl:pt-[195px] text-center">
    <div class="container 2xl:max-w-[1320px] mx-auto px-[12px] relative z-[1]">
        <h1
            class="!mb-0 !leading-[1.2] !text-3xl md:!text-5xl lg:!text-[50px] xl:!text-[60px] -tracking-[.5px] md:-tracking-[1px] xl:-tracking-[1.5px]">
            Strip Debug Info
        </h1>
        @if(sessionId){
        <h3 class="text-blue-500 mt-2">User SessionId: {{ sessionId }}</h3>
        }

        @if(isSuccess){
        <p class="text-green-500 mt-4">Payment successful!</p>
        }
        @else if(isFailure){
        <p class="text-red-500 mt-4">Payment failed or was cancelled.</p>
        }
        <h5>SessionInfo : </h5>
        <h5>Stripe PaymentId : {{stripePaymentId()}}</h5>
        <h5>Stripe Payment Status : {{stripeStatus()}}</h5>
        <h4>Finaliser l'ordre & envoyer le message à roger</h4>

    </div>
</div>